import React from 'react';
import { XIcon } from 'lucide-react';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyModal({
  isOpen,
  onClose
}: PrivacyModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4 backdrop-blur-sm" data-id="element-212">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-213">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between" data-id="element-214">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-215">
            Política de Privacidad y Protección de Datos
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-50 rounded-lg" data-id="element-216">
            <XIcon className="h-5 w-5" data-id="element-217" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 space-y-5 text-sm text-gray-600 leading-relaxed" data-id="element-218">
          <div className="text-center mb-6" data-id="element-219">
            <h3 className="text-lg font-bold text-gray-900" data-id="element-220">
              Política de Privacidad y Protección de Datos
            </h3>
          </div>

          <section data-id="element-221">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-222">1. INTRODUCCIÓN</h4>
            <p data-id="element-223">
              En TicketMaestro valoramos y respetamos la privacidad de nuestros
              usuarios. Esta Política de Privacidad describe cómo recopilamos,
              utilizamos, almacenamos y protegemos los datos personales que
              usted nos proporciona al utilizar nuestros sitios, APPs,
              terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>
          </section>

          <section data-id="element-224">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-225">
              2. RESPONSABLE DEL TRATAMIENTO
            </h4>
            <ul className="space-y-1" data-id="element-226">
              <li data-id="element-227">
                <strong data-id="element-228">Nombre de la entidad:</strong> TicketMaestro SAS
              </li>
              <li data-id="element-229">
                <strong data-id="element-230">Dirección Legal:</strong> Edificio The Point, Oficina
                1803, Puerto Santa Ana, Guayaquil, Ecuador.
              </li>
              <li data-id="element-231">
                <strong data-id="element-232">Correo electrónico de contacto:</strong>{' '}
                <span className="text-brand-600" data-id="element-233">contacto@benefica.net</span>
              </li>
            </ul>
          </section>

          <section data-id="element-234">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-235">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h4>
            <p className="mb-2" data-id="element-236">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-237">
              <li data-id="element-238">Nombres y apellidos</li>
              <li data-id="element-239">Número de Cédula</li>
              <li data-id="element-240">Correo electrónico</li>
              <li data-id="element-241">Número de teléfono</li>
              <li data-id="element-242">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-243">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
            </ul>
          </section>

          <section data-id="element-244">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-245">
              4. FINALIDAD DEL TRATAMIENTO
            </h4>
            <p className="mb-2" data-id="element-246">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-247">
              <li data-id="element-248">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-249">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-250">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-251">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-252">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-253">Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </section>

          <section data-id="element-254">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-255">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h4>
            <p className="mb-2" data-id="element-256">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-257">
              <li data-id="element-258">Tu consentimiento expreso</li>
              <li data-id="element-259">
                El interés legítimo de Benefika para cumplir su misión
                institucional
              </li>
              <li data-id="element-260">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>
          </section>

          <section data-id="element-261">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-262">
              6. DESTINATARIOS DE LOS DATOS
            </h4>
            <p className="mb-2" data-id="element-263">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-264">
              <li data-id="element-265">Tengamos tu consentimiento previo</li>
              <li data-id="element-266">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-267">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios) con contratos que
                garantizan la protección de tus datos
              </li>
            </ul>
          </section>

          <section data-id="element-268">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-269">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h4>
            <p className="mb-2" data-id="element-270">Tienes derecho a:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-271">
              <li data-id="element-272">Acceder a tus datos personales</li>
              <li data-id="element-273">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-274">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-275">Oponerte al tratamiento</li>
              <li data-id="element-276">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-277">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-3" data-id="element-278">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <span className="font-medium text-brand-600" data-id="element-279">
                protecciondatos@benefica.net
              </span>
            </p>
          </section>

          <section data-id="element-280">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-281">8. USO DE COOKIES</h4>
            <p data-id="element-282">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </section>

          <section data-id="element-283">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-284">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h4>
            <p data-id="element-285">
              Benefika aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </section>

          <section data-id="element-286">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-287">
              10. CONSERVACIÓN DE LOS DATOS
            </h4>
            <p data-id="element-288">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </section>

          <section data-id="element-289">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-290">
              11. CAMBIOS A ESTA POLÍTICA
            </h4>
            <p data-id="element-291">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>
          </section>

          <section data-id="element-292">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-293">
              12. AUTORIDAD DE CONTROL
            </h4>
            <p data-id="element-294">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </section>

          <section data-id="element-295">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-296">13. VIGENCIA</h4>
            <p data-id="element-297">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 21 de noviembre de 2025 y permanecerá vigente hasta
              que exista una nueva versión que la reemplace.
            </p>
          </section>

          <div className="pt-4 border-t border-gray-200 text-xs text-gray-500" data-id="element-298">
            Última actualización: 21 de noviembre de 2025
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-100 px-6 py-4 bg-gray-50" data-id="element-299">
          <button onClick={onClose} className="w-full bg-brand-600 text-white py-3 rounded-lg font-semibold hover:bg-brand-700 transition-colors" data-id="element-300">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}